import { FileText, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { QuickActionCard } from './QuickActionCard'

/**
 * Bottom 3-up grid of shortcut cards (create investigation, manage leads,
 * go live) — purely navigational, no data fetching.
 */
export function QuickActionsSection() {
  const { t } = useTranslation()

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <QuickActionCard
        title={t('admin.dash_quick_create_title')}
        description={t('admin.dash_quick_create_desc')}
        href="/manage/investigations/create"
        icon={FileText}
      />
      <QuickActionCard
        title={t('admin.dash_quick_live_title')}
        description={t('admin.dash_quick_live_desc')}
        href="/manage/live"
        icon={Users}
      />
    </div>
  )
}
